import { createFeatureSelector } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';

import * as fromCore from './core.reducer';

export const selectRouter = createFeatureSelector<
    fromCore.State,
    fromRouter.RouterReducerState<any>
>('router');

export const {
    selectQueryParam, // factory function to select a query param
    selectQueryParams, // select the current route query params
    selectRouteData, // select the current route data
    selectRouteParam, // factory function to select a route param
    selectRouteParams, // select the current route params
    selectUrl // select the current url
} = fromRouter.getRouterSelectors(selectRouter);

export const RouterSelectors = {
    selectQueryParam,
    selectQueryParams,
    selectRouteData,
    selectRouteParam,
    selectRouteParams,
    selectUrl
};
